import React from 'react';
import useCustomNavigate from '../../../hooks/useCustomNavigate';

const PremiumServices = ({setHoveredItem}) => {

    const {goTo} = useCustomNavigate()

  const services = [
    { name: 'Interior Designer', description: 'This is a premium service.' },
    { name: 'Vastu Facilities', description: 'This is another premium service.' },
    { name: 'Home Services', description: 'This is a third premium service.' },
    { name: 'Movers & Packers', description: 'This is a fourth premium service.' },
    { name: 'Legal Team', description: 'This is a fifth premium service.' },
    { name: 'Modular Kitchens', description: 'This is a sixth premium service.' },
    { name: 'Construction Companies', description: 'This is a seventh premium service.' },
    { name: 'Furniture', description: 'This is an eighth premium service.' }
  ];

  

  return (
    <div className="bg-white p-6 rounded-b-lg shadow-md border-b-2 border-l-2 border-r-2 border-gray-400">
      <div className="flex items-start">
        {/*  Left side: Add Services */}
        <div className="w-[30%] flex justify-center items-center border-r border-gray-300 pr-6">
          <button 
          className="bg-blue-500 text-white py-2 px-6 rounded-md hover:bg-blue-700 transition duration-200"
          onClick={()=>{
            goTo("/addservice");
            setHoveredItem("")
            
        }}
          >
            Add Services
          </button>
        </div>

        {/* Right side: Buy Services */}
        <div className="w-[65%] pl-6 group">
          <h3 className="text-xl font-semibold text-gray-700 mb-4">Buy Services</h3>

          {/* Grid layout for services */}
          <div
            className="h-[200px] overflow-y-auto group-hover:overflow-y-scroll"
            style={{ maxHeight: '200px' }}  // Limit the height for scrolling
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {services.map((service, index) => (
                <button
                  key={index}
                  onClick={()=>{goTo(`/service/list/${service?.name?.replace(/ /g, '-')}`)}}
                  className="bg-[#2b463c] text-white text-xs py-2  rounded-md hover:bg-green-700 transition duration-200 flex flex-col justify-center items-center"
                >
                  <h5 className="text-sm  font-medium">{service.name}</h5>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PremiumServices;
